export default __webpack_public_path__ + "static/media/ms_sans_serif.0348082a.woff2";